import { makeStyles } from '@material-ui/core/styles';
import EventIcon from '@material-ui/icons/Event';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import landingPageStyle from 'assets/jss/material-kit-pro-react/views/landingPageStyle.jsx';
import CustomFooter from 'components/Footer/CustomFooter.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CustomHeader from 'components/Header/CustomHeader.jsx';
import ReactParallax from 'components/Parallax/Parallax.jsx';
import SEOHeader from 'components/SEOHeader/SEOHeader.jsx';
import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { getEventDate } from 'helpers/Functions.jsx';
import moment from 'moment';
import React from 'react';

import SectionAbout from './Sections/SectionAbout.jsx';
import SectionAdmission from './Sections/SectionAdmission.jsx';
import SectionCookOff from './Sections/SectionCookOff.jsx';
import SectionEventInfo from './Sections/SectionEventInfo.jsx';
import SectionHeadliner from './Sections/SectionHeadliner.jsx';
import SectionParticipation from './Sections/SectionParticipation.jsx';
import SectionSponsor from './Sections/SectionSponsor.jsx';
import SectionTickets from './Sections/SectionTickets.jsx';
import SectionTimer from './Sections/SectionTimer.jsx';

const useStyles = makeStyles(landingPageStyle);

const countryEdgeDate = getEventDate('countryEdge');
const chilimaniaDate = getEventDate('chilimania');
console.log(countryEdgeDate);
console.log(chilimaniaDate);

export default function LandingPage() {
  const { audienceBackground, chiliDude } = useStaticQuery(graphql`
    query getLandingPageImages {
      audienceBackground: file(
        relativePath: { eq: "banners/concert-audience.jpg" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
      chiliDude: file(relativePath: { eq: "logos/chili-dude.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
  `);
  const classes = useStyles();
  return (
    <div id="landingPage">
      <SEOHeader title="Chilimania - Chili | Beer | Bands | Fun" />
      <CustomHeader />
      <ReactParallax
        imageData={audienceBackground.childImageSharp.gatsbyImageData}
        imageTitle={'Admissions Banner'}
        imageStyle={{ height: '100vh' }}
        filter="dark"
        className={classes.headerParallax}
        alignItems={'center'}
      >
        <div className={classes.bannerContainer}>
          <GridContainer className={classes.bannerRow}>
            <GridItem xs={12} sm={12} md={6} className={classes.welcomeMessage}>
              <div className={classes.tagline}>
                <h2 className={classes.bannerTitle}>CHILI.</h2>
                <h2 className={classes.bannerTitle}>BEER.</h2>
                <h2 className={classes.bannerTitle}>BANDS.</h2>
                <h2 className={classes.bannerTitle}>FUN.</h2>
              </div>
              <h3 className={classes.message}>
                <i>Celebrating Charity Through Music &amp; Chili</i>
              </h3>
              {/* <p className={classes.description}>
                Online ticket sales are closed. General admission tickets are
                still available at the gate.
              </p> */}
              {/* <Button
                href="https://www.eventeny.com/events/ticket/?id=28844&ref=chilimania"
                color="primary"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Purchase Chilimania tickets (opens in new tab)"
              >
                Buy Tickets Now
              </Button> */}
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              <GridContainer>
                <GridItem xs={6} sm={6} md={12} className={classes.date}>
                  <EventIcon className={classes.iconLarge} />
                  <h3 className={classes.bannerHeader}>When</h3>
                  <h4 className={classes.bannerInfo}>
                    {moment(countryEdgeDate).format('ddd, MMMM D')} <br />
                    &amp; {moment(chilimaniaDate).format('ddd, MMMM D')}
                  </h4>
                </GridItem>
                <GridItem xs={6} sm={6} md={12} className={classes.location}>
                  <LocationOnIcon className={classes.iconLarge} />
                  <h3 className={classes.bannerHeader}>Where</h3>
                  <h4 className={classes.bannerInfo}>
                    N Henry St, Edgerton, Wisconsin
                  </h4>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
        </div>
      </ReactParallax>
      <div className={classes.main}>
        <div className={classes.chiliDudeContainer}>
          <GatsbyImage
            image={chiliDude.childImageSharp.gatsbyImageData}
            className={classes.chiliDude}
            alt="Chili Dude"
          />
        </div>
        <SectionAbout />
        <SectionHeadliner />
        <SectionAdmission />
        <SectionTickets />
        <SectionCookOff />
        <SectionParticipation />
        <SectionEventInfo />
        <SectionSponsor />
        <SectionTimer />
        <CustomFooter />
      </div>
    </div>
  );
}
